export const scrollSection = (id) => {
  const idScroll = document.getElementById(id);
  if (idScroll) {
    idScroll.scrollIntoView({ behavior: "smooth" });
  }
};
